import React from 'react'
import { Answer } from '@/domains/Answer'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

type AnswersRadioGroupProps = {
  checked: boolean
  selectedAnswer: Answer
  setAnswer: (answer: Answer) => void
  disabled?: boolean
}

const AnswersRadioGroup = ({
  checked,
  selectedAnswer,
  setAnswer,
  disabled = false,
}: AnswersRadioGroupProps) => {
  const { t } = useTranslation('common')
  return (
    <label
      key={selectedAnswer}
      data-testid={`answer-option-${selectedAnswer}`}
      className={twMerge(
        'w-full flex items-center gap-3 border rounded-md px-4 py-3 cursor-pointer transition-shadow',
        checked ? 'border-primary-blue shadow-md' : 'border-gray-200',
        disabled ? 'bg-gray-100' : ''
      )}
    >
      <input
        type="radio"
        name="question"
        value={selectedAnswer}
        checked={checked}
        onChange={() => setAnswer(selectedAnswer)}
        className="sr-only"
        disabled={disabled}
        aria-checked={checked}
      />

      <span
        className={twMerge(
          'lex-none w-5 h-5 rounded-full border flex items-center justify-center',
          checked ? 'bg-primary-blue border-primary-blue' : 'bg-white border-gray-300',
          disabled ? 'bg-gray-100' : ''
        )}
        aria-hidden
      >
        {checked && (
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d="M20 6L9 17l-5-5"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      <span className="text-gray-800">{t(`pages.questions.${selectedAnswer.toLowerCase()}`)}</span>
    </label>
  )
}

export default AnswersRadioGroup
